import i18n from '../../../../i18n';
import { getHandelsRegisterData, getVestigingsProfielData } from '../../../../services/utilities/apis/kvk';
import { isPointInsideOrgPolygonOrBBox } from '../../../../services/map/boundingBox';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import { TAB_STATUS } from '../../../../constants';

const store = {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        async getKvkCompanies({ dispatch, commit }, { name, data, title }) {
            //Clear possible results for this title and open new tab with status Loading
            dispatch('initTabObjectSearch', { title });

            try {
                let result;

                // If data has no fields then we are looking for companies without having clicked on an address
                // Make a copy of the data object and remove the fixed field "InclusiefInactieveRegistraties" and any
                // properties with an undefined value.
                let dataWithoutInactive = { ...data };
                delete dataWithoutInactive.InclusiefInactieveRegistraties;
                Object.keys(dataWithoutInactive).forEach(key => dataWithoutInactive[key] === undefined && delete dataWithoutInactive[key]);

                // If the object is now empty we will create an empty search result without calling the API.
                // Otherwise the API will return all results based on empty search parameters.
                if (Object.keys(dataWithoutInactive).length === 0) {
                    result = { 'data': [] };
                } else {
                    // call the API
                    result = await dispatch('useApiData', { name: name, data });
                }

                const companyData = getHandelsRegisterData(data, result.data);
                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: companyData,
                    count: result.data?.length ?? 0,
                    exportable: true,
                    download: true,
                    printable: true,
                    status: TAB_STATUS.READY
                });
                dispatch('trackUserEvent', { name: 'getKvkCompanies', stage: name });
            } catch (err) {

                // set message to the error message as default
                let message = err.message;
                // The response may contain a message with more information
                const response = err?.data?.request?.response;

                if (response) {
                    // Parse the response as JSON and get the message
                    const responseJson = JSON.parse(response);
                    if (responseJson.message) {
                        // Set the message to the response message
                        message = responseJson.message;
                    }
                }

                commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: {
                        'items': [],
                        'fields': []
                    },
                    maxResultsExceeded: false,
                    count: 0,
                    status: TAB_STATUS.ERROR,
                    message: message
                });
            }
        },

        async GetKvkVestigingsProfiel(store, { data }) {
            const title = i18n.t('kvk.locationProfile');

            //Clear possible results for this title and open new tab with status Loading
            store.dispatch('initTabObjectSearch', { title });

            try {
                const result = await store.dispatch('useApiData', {
                    name: 'GetVestigingsProfielData',
                    parameters: { Vestigingsnummer: data.vestigingsnummer }
                });
                const vestigingsProfielData = getVestigingsProfielData(result.data);

                let feature = null;
                let pointInsideBbox = true;
                let zoomToFeatures = true;

                if (vestigingsProfielData && vestigingsProfielData.items.length > 0) {
                    const geoData = vestigingsProfielData.items[0].geoData;
                    feature = geoData ? new Feature({ geometry: new Point([geoData.rijksdriehoekX, geoData.rijksdriehoekY]) }) : null;
                    pointInsideBbox = isPointInsideOrgPolygonOrBBox(store.getters.getUserData, feature?.getGeometry());
                    zoomToFeatures = pointInsideBbox;
                }

                store.commit('CLEAR_OBJECT_DATA', { title });
                store.commit('CLEAR_TABORDER_DATA', { title });
                store.commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: vestigingsProfielData,
                    count: result.data ? 1 : 0,
                    exportable: true,
                    download: true,
                    printable: true,
                    kvkTradeRegister: true,
                    features: feature ? [feature] : [],
                    zoomToFeatures,
                    pointInsideBbox,
                    status: TAB_STATUS.READY
                });
                store.dispatch('trackUserEvent', { name: 'getKvkVestigingsProfiel' });
            } catch (err) {
                store.commit('UPDATE_LOADING_OBJECT_DATA', {
                    title,
                    data: {
                        'items': [],
                        'fields': []
                    },
                    maxResultsExceeded: false,
                    count: 0,
                    status: TAB_STATUS.ERROR,
                    message: err.message
                });
            }
        },

        async highlightVestiging(store, { item }) {
            const geoData = item.geoData;
            const feature = geoData ? new Feature({ geometry: new Point([geoData.rijksdriehoekX, geoData.rijksdriehoekY]) }) : null;
            const pointInsideBbox = isPointInsideOrgPolygonOrBBox(store.getters.getUserData, feature?.getGeometry());
            store.dispatch(
                'selectAndZoomToApiResultPointFeatures', {
                    data: {
                        highlight: true,
                        zoomToFeatures: true,
                        pointInsideBbox,
                        features: feature ? [feature] : []
                    }
                });
        },
    }
};

export default store;
